"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var AxiosOperationExecutorBuilder = (function () {
    function AxiosOperationExecutorBuilder(axios, metricService, logService) {
        this.axios = axios;
        this.metricService = metricService;
        this.logService = logService;
    }
    AxiosOperationExecutorBuilder.prototype.build = function () {
        var _this = this;
        return function (metadata, operation, request) { return __awaiter(_this, void 0, void 0, function () {
            var serviceName, successMetricHandle, failureMetricHandle, response, config, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serviceName = metadata.serviceFullName.replace(/ /gi, "");
                        if (!operation.http) {
                            throw new Error("Only Http Operations are supported");
                        }
                        successMetricHandle = this.metricService.newLatencyMetric(serviceName + "." + operation.name + ".Success");
                        failureMetricHandle = this.metricService.newLatencyMetric(serviceName + "." + operation.name + ".Failed");
                        config = this.createRequestConfig(operation, request);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios(config)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (error_1.response) {
                            this.logService.log({
                                Event: "AJAX_CALL_ERROR_EVENT",
                                ApiOperationName: operation.name,
                                Metadata: JSON.stringify(error_1.message) + 'data: ' + JSON.stringify(error_1.response.data),
                                RequestId: error_1.response.headers["x-amzn-requestid"],
                                CallUrl: error_1.response.config.url,
                                StatusCode: error_1.response.status.toString() || '',
                                Method: lodash_1.toUpper(error_1.response.config.method),
                                ErrorStack: error_1.stack,
                            });
                        }
                        else {
                            this.logService.log({
                                Event: "AJAX_CALL_ERROR_EVENT",
                                ApiOperationName: operation.name,
                                ErrorMessage: error_1.message,
                                ErrorStack: error_1.stack,
                            });
                        }
                        failureMetricHandle.stopAndEmitMetric();
                        throw error_1;
                    case 4:
                        successMetricHandle.stopAndEmitMetric();
                        this.logService.log({
                            Event: "AJAX_CALL_COMPLETE_EVENT",
                            ApiOperationName: operation.name,
                            RequestId: response.headers["x-amzn-requestid"],
                            CallUrl: response.config.url,
                            StatusCode: response.status.toString() || '',
                            Method: lodash_1.toUpper(response.config.method)
                        });
                        return [2 /*return*/, response.data];
                }
            });
        }); };
    };
    AxiosOperationExecutorBuilder.prototype.createRequestConfig = function (operation, request) {
        var config = {};
        // Determin request method
        config.method = operation.http.method;
        // Add all request values to approperate location
        if (operation.input && operation.input.shape.members) {
            var allPossibleMembers_1 = operation.input.shape.members;
            var requestUrl_1 = operation.http.requestUri;
            lodash_1.forOwn(request, function (value, requestParamName) {
                var _a = allPossibleMembers_1[requestParamName], location = _a.location, locationName = _a.locationName;
                // notice that locationName might be different from requestParamName
                // e.g. requestParamName is "Marker" while locationName is "marker"
                if (value && typeof value !== 'string') {
                    value = value.toString();
                }
                if (!!location && !!locationName) {
                    switch (location) {
                        case "uri":
                            if (value === undefined) {
                                throw new Error("Undefined request property found when doing URI substitution");
                            }
                            requestUrl_1 = requestUrl_1.replace("{" + locationName + "}", value);
                            break;
                        case "querystring":
                            if (!config.params) {
                                config.params = {};
                            }
                            config.params[locationName] = value;
                            break;
                        case "header":
                            if (!config.headers) {
                                config.headers = {};
                            }
                            config.headers[locationName] = value;
                            break;
                        default:
                            break;
                    }
                }
            });
            config.url = requestUrl_1;
        }
        // Add request to the request body
        config.data = request;
        return config;
    };
    return AxiosOperationExecutorBuilder;
}());
exports.AxiosOperationExecutorBuilder = AxiosOperationExecutorBuilder;
